import { render, staticRenderFns } from "./GroupPicker.vue?vue&type=template&id=136dee44"
import script from "./GroupPicker.vue?vue&type=script&lang=js"
export * from "./GroupPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports